import React, { useState } from "react";
import "./Contact.scss";
import Footer from "../../Component/Footer/Footer";
import Whatsapp from "../../Component/Whatsapp/Whatsapp";
import { BASE_URL } from "../../environments/config";
import { Helmet } from 'react-helmet';
import seoData from "../../Seo";
import Header from "../../Component/Header";
import Loader from "../../Component/Loader/Loader";
import {logEvent} from "../../Utils/Analytics";
import { EVENT_CATEGORIES, EVENT_ACTIONS, EVENT_LABELS } from "../../Constants/myDharmaContent";
export default function ContactUs() {

  const pageUrl = seoData["contact"]?.PageURL;
  const metaTitle = seoData["contact"]?.MetaTitle;
  const metaDescription = seoData["contact"]?.MetaDescription;
  const metaKeywords = seoData["contact"]?.Keywords;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    reason: "Select Reason",
    message: ""
  });
  const [res, setRes] = useState("");
  const [isLoading, setIsLoading] = useState(false); 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleContactFormSubmit = () => {
    logEvent(EVENT_CATEGORIES.ENQUIRY,EVENT_ACTIONS.CONTACT_US_FORM, EVENT_LABELS.SUBMIT);
  };

  const handleSubmit = (e) => {
    handleContactFormSubmit();
    e.preventDefault();
    setIsLoading(true); 
    const { firstName, lastName, email, phoneNumber, message } = formData;
    fetch(`${BASE_URL}/users/contact-karishye`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phoneNumber,
        message,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error occured during post call");
        }
        setIsLoading(false);
        return response.json();
      })
      .then((data) => {
        setRes(data?.message);
      })
      .catch((error) => {
        console.error("There was a problem with your fetch operation:", error);
        setIsLoading(false);
      });

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      reason: "Select Reason",
      message: "",
    });
  };

  return (
    <>
      {isLoading && <Loader fullScreen />}
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <Header />
      <div className="contactUsSection">
        <div className="cntpgfstcontsec">
          <div className="container">
            <div className="content-wrapper">
              <h1>Contact Us</h1>
              <img
                src="/assets/images/about-us-top.png"
                alt="Contact-Icon"
                className="hero-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div className="cntpgsndcontsec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h2 className="contacttext">
                  Just Say <strong className="contacttext">HELLO!</strong>
                </h2>
                <div className="row">
                  <div className="col-log-6 col-md-6">
                    <div className="labelSection">
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-3">
                          <img
                            src="/assets/images/contactpgwhatsapp.png"
                            alt="Whatsapp-Icon"
                            loading="lazy"
                          />
                        </div>
                        <div className="col-lg-9 col-md-9 col-9">
                          <h3>Chat</h3>
                          <p>
                            <a href="https://wa.me/+%REACT_APP_MOBILE_NUMBER_1%">
                              {process.env.REACT_APP_MOBILE_NUMBER_1}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-log-6 col-md-6">
                    <div className="labelSection">
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-3">
                          <img src="/assets/images/mailicon.png" alt="Mail-Icon" loading="lazy" />
                        </div>
                        <div className="col-lg-9 col-md-9 col-9">
                          <h3>Email</h3>
                          <p>
                            <a href="mailto:%REACT_APP_CONTACT_EMAIL%">
                              {process.env.REACT_APP_CONTACT_EMAIL}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-log-6 col-md-6">
                    <div className="labelSection">
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-3">
                          <img
                            className="phone-icon"
                            src="/assets/images/phoneicon.png"
                            alt="Phone-Icon"
                            loading="lazy"
                          />
                        </div>
                        <div className="col-lg-9 col-md-9 col-9">
                          <h3>Call</h3>
                          <p>{process.env.REACT_APP_MOBILE_NUMBER_1}</p> {/*displays the mobile number from the .env file */}
                          <p>{process.env.REACT_APP_MOBILE_NUMBER_2}</p>
                          <p>{process.env.REACT_APP_MOBILE_NUMBER_3}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-log-6 col-md-6">
                    <div className="labelSection">
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-3">
                        </div>
                        <div className="col-lg-9 col-md-9 col-9">
                          <h3>Address</h3>
                          <p>Plot no:- 107,SriSri Nagar,Venkateshwara Swamy Temple Rd, Uppal, Hyderabad, Telangana 500039</p> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cntpgtrdcontsec">
                  <h2>
                    Send <strong className="contacttext">Message</strong>
                  </h2>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <input
                          type="text"
                          name="email"
                          placeholder="Email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          name="phoneNumber"
                          placeholder="Phone"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <select
                          name="reason"
                          value={formData.reason}
                          onChange={handleChange}
                          required
                        >
                          <option value="Select Reason">Select Reason</option>
                          <option value="Astrology/Horoscope Help">
                            Astrology/Horoscope Help
                          </option>
                          <option value="For Bulk Puja/Corporate Booking">
                            For Bulk Puja/Corporate Booking
                          </option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <textarea
                          name="message"
                          placeholder="Message"
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <input
                          className="submit"
                          type="submit"
                          value="submit"
                        />
                      </div>
                    </div>
                  </form>
                  {res && <div className="response">{res}</div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Whatsapp />
    </>
  );
}
